const dashboardRoutes = [
  {
    id: 'overview',
    name: 'Overview',
  },
  {
    id: 'discovery',
    name: 'Discovery',
  },
  // {
  //   id: 'benchmarking',
  //   name: 'Benchmarking',
  // },
  {
    id: 'portfolio',
    name: 'Portfolio',
  },
  {
    id: 'asset-analysis',
    name: 'Asset Analysis',
  },
  {
    id: 'nebula-search',
    name: 'Nebula',
  },
  // {
  //   id: 'scam-detection', ScamDetection
  //   name: 'Scam Detection',
  // },
  // {
  //   id: 'asset-logs',
  //   name: 'Asset Logs',
  // },
  // {
  //   id: 'block-information', TokenTopology
  //   name: 'Block Information',
  // }, 
]

export default dashboardRoutes